import React, { Component } from "react";
import {  Modal } from "react-bootstrap";
import WithholdingList from "containers/property/WithholdingList";



export default class WithholdingModal extends Component {
    constructor(props) {
        super(props);

        this.state = {
         
            isLoading: true,
            
        };

        
     
       
    }
    

    async componentDidMount() {
        console.log("In WithholdingModal componentDidMount");
        if (!this.props.isAuthenticated) { // if false
            return;
        }

        if (!this.props.show) {
            return null;
        }

           
    }

    componentWillUnmount() {
        this.setState({ entities: [] });
    }


    

    renderWithholdinges() {
        return (
            
            <Modal
                show={this.props.show}
                onHide={this.props.toggleWithholdingModal}
                dialogClassName="modal-90w"
                >
                <Modal.Header closeButton>
                    <Modal.Title></Modal.Title>
                </Modal.Header>
                <Modal.Body style={{ 'overflowX': 'scroll' }}>
           


                        <WithholdingList
                        filter={this.props.filter}
                        isAuthenticated={this.props.isAuthenticated}
                        isLoading={this.state.isLoading}
                        controlType="table"
                        saveForm={this.props.saveForm}
                        user={this.props.user}
                        data={this.props.data}
                        updateTableState={this.props.updateTableState}
                        saveRecord={this.props.saveRecord}
                        bulkSaveRecords ={this.props.bulkSaveRecords}
                        deleteRecord={this.props.deleteRecord}
                        validateRelatedRecord={this.props.validateRelatedRecord}
                        withholdingReasons={this.props.withholdingReasons}
                        userPermissions={this.props.userPermissions}
                        />

                  
          
                    </Modal.Body>
            </Modal>
        );
    }
    
    


    render() {
        return (

            <div className="WithholdingEdit">
                {this.props.isAuthenticated ? this.renderWithholdinges() : console.log("error)")}
            </div>
        );
    }
}
